import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `pie_chart` component.
 * Keep in sync with PieChartProps in src/ui/uiConfig/components/PieChart/PieChart.types.ts
 */
export const pieChartPropDocs: ComponentDocMap = {
  items: {
    description: 'Pie/ring segment definitions. Each item links to a dataset via data_id.',
    type: 'StackedChartItem[]',
    example: '[{ title: "__Boiler", data_id: "boiler", stack_group: 0, color: "$color-1" }]',
  },
  'items[].order': {
    description: 'Order inside stack group.',
    type: 'number | string',
  },
  stack_groups: {
    description: 'Ring/group definitions used to combine items.',
    type: 'StackGroup[]',
    example: '[{ id: 0, title: "__Actual" }, { id: 1, title: "__Optimal" }]',
  },
  'stack_groups[].title': {
    description: 'Display label for the ring/group.',
    type: 'string',
  },
  'stack_groups[].id': {
    description: 'Group identifier referenced by items[].stack_group.',
    type: 'string | number',
  },
  'stack_groups[].include_only_base_items_with_attr': {
    description: 'Optional attribute filter for base items included in this group.',
    type: 'Record<string, boolean | number | string | null>',
    example: '{ "h_energy_bar": true }',
  },
  title: {
    description: 'Title displayed above the pie chart.',
    type: 'string',
    example: '"__Production split"',
  },
  data_type: {
    description: 'Fallback data_type applied when items do not define one.',
    type: 'string',
    example: '"energy"',
  },
}
